module.exports = "<svg height=\"16\" width=\"16\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zM6.24 10.82l.66.65.6-.72 4.86-5.63-1.32-1.09L6.9 9.15 4.6 6.76 3.4 7.99l2.84 2.83zm0 0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/icon/icons/valid.svg
// module id = 891
// module chunks = 0